/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Location_LabelInputs */

const en_job_form_location_label = /** @type {(inputs: Job_Form_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_job_form_location_label = /** @type {(inputs: Job_Form_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Job_Form_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_location_label = /** @type {((inputs?: Job_Form_Location_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Location_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_location_label(inputs)
	return en_job_form_location_label(inputs)
});